import React from "react";
import EPubTable from "./components/EPubTable";

const EPubTableContainer = () => {
    return <EPubTable />
}

export default EPubTableContainer;